import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const stores = new Vuex.Store({

    modules: {
        ...require('@/aplicacao/_configuracoes/stores').default,
    },

})

export default stores
